import React from "react";
import AllEquitiesWelcome from "./AllEquitiesWelcome/AllEquitiesWelcome";
import AllEquitiesFilter from "./AllEquitiesFilter/AllEquitiesFilter";
function AllEquities() {
  return (
    <>
      <AllEquitiesWelcome />
      <AllEquitiesFilter />
    </>
  );
}
export default AllEquities;
